import React from 'react'
import { I18n } from '@front/volcanion/'

import { Grid, StepLabel, StepContent } from '@mui/material'
import { TextField, TextPhoneInputField, SingleOptionSelectorField } from '@front/squirtle'
import { SuspensionTitleForm } from '@abra/elements/Suspensions'

const GridComponent = ({ isManagingRecord, searchGSM, user_id, defaultCountry }) => (
  <Grid container rowSpacing={1} spacing={2} sx={{ p: 2, boxShadow: 6, borderRadius: 1 }}>
    <Grid size="grow">
      <TextPhoneInputField
        name={'contact.gsm'}
        label={I18n.t('phone.gsm')}
        afterChange={searchGSM}
        defaultCountry={defaultCountry}
        disabled={!!isManagingRecord}
        debounceTime={250}
        required
      />
    </Grid>
    <Grid size="grow">
      <TextField
        name={'contact.last_name'}
        label={I18n.t('name.label', { count: 1 })}
        emptyValue='-'
        required={!user_id}
      />
    </Grid>
    <Grid size="grow">
      <TextField
        name={'contact.first_name'}
        label={I18n.t('name.first_name', { count: 1 })}
        emptyValue='-'
        required={!user_id}
      />
    </Grid>
    <Grid size="grow">
      <SingleOptionSelectorField
        name='priority'
        label={I18n.t('priority.label.order')}
        clearOnEmpty={false}
      />
    </Grid>
  </Grid>
)

const PrimarySection = ({ record_id, ...rest }) => <>
  <StepLabel>
    <SuspensionTitleForm label={I18n.t('user.info')} record_id={record_id} model_name={"companyuser"} />
  </StepLabel>
  <StepContent>
    <GridComponent {...rest} />
  </StepContent>
</>

export default React.memo(PrimarySection)
